import { render } from "./ContactReceived.vue?vue&type=template&id=f3a97dd0&scoped=true&lang=pug"
import script from "./ContactReceived.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactReceived.vue?vue&type=script&setup=true&lang=js"

import "./ContactReceived.vue?vue&type=style&index=0&id=f3a97dd0&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3a97dd0"]])

export default __exports__